/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 获取列表 的 **请求配置**
 *
 * @分类 商运API/人员管理
 * @请求头 `POST /erp/BusinessOperator/getList`
 */
const postGetListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/BusinessOperator/getList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取列表 的 **请求函数**
 *
 * @分类 商运API/人员管理
 * @请求头 `POST /erp/BusinessOperator/getList`
 */
export const postGetList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetListRequestConfig, requestData), ...args);
};
postGetList.requestConfig = postGetListRequestConfig;
/**
 * 接口 列表枚举 的 **请求配置**
 *
 * @分类 商运API/人员管理
 * @请求头 `GET /erp/BusinessOperator/getEnumsForList`
 */
const getGetEnumsForListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/BusinessOperator/getEnumsForList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetEnumsForList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 列表枚举 的 **请求函数**
 *
 * @分类 商运API/人员管理
 * @请求头 `GET /erp/BusinessOperator/getEnumsForList`
 */
export const getGetEnumsForList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetEnumsForListRequestConfig, requestData),
    ...args
  );
};
getGetEnumsForList.requestConfig = getGetEnumsForListRequestConfig;
/**
 * 接口 新增单个商运人员 的 **请求配置**
 *
 * @分类 商运API/人员管理
 * @请求头 `POST /erp/BusinessOperator/addOne`
 */
const postAddOneRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/BusinessOperator/addOne",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postAddOne",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 新增单个商运人员 的 **请求函数**
 *
 * @分类 商运API/人员管理
 * @请求头 `POST /erp/BusinessOperator/addOne`
 */
export const postAddOne = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postAddOneRequestConfig, requestData), ...args);
};
postAddOne.requestConfig = postAddOneRequestConfig;
/**
 * 接口 更新商运人员 的 **请求配置**
 *
 * @分类 商运API/人员管理
 * @请求头 `POST /erp/BusinessOperator/updateOne`
 */
const postUpdateOneRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/BusinessOperator/updateOne",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateOne",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 更新商运人员 的 **请求函数**
 *
 * @分类 商运API/人员管理
 * @请求头 `POST /erp/BusinessOperator/updateOne`
 */
export const postUpdateOne = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postUpdateOneRequestConfig, requestData), ...args);
};
postUpdateOne.requestConfig = postUpdateOneRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/businessOperator.js